import React, { useEffect, useState, useRef } from 'react';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section ref={heroRef} className="relative text-slate-900 overflow-hidden" data-id="element-40">
      {/* Background image with blur overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/f4q6Gqm5U1zLffGWz2WcES/Firefly_Gemini_Flash-11.png')`,
      filter: 'blur(3px)',
      transform: 'scale(1.05)'
    }} data-id="element-41" />
      {/* Dark overlay so text pops */}
      <div className="absolute inset-0 bg-white/75" data-id="element-42" />

      <div className="max-w-6xl mx-auto px-4 py-12 md:py-16 relative z-10" data-id="element-43">
        <div className="flex flex-col items-center text-center gap-6" data-id="element-44">
          {/* Badge */}
          <div className={`inline-block bg-blue-50 text-blue-600 text-sm font-semibold px-5 py-2 rounded-full border border-blue-100 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`} data-id="element-45">
            ⚡ Para docentes de nivel secundario
          </div>

          {/* Main Heading */}
          <div className={`max-w-4xl transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`} data-id="element-46">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6" data-id="element-47">
              ORGANIZA TODO TU AÑO DE{' '}
              <span className="text-orange-500" data-id="element-48">SIC SIN ESTRÉS</span>
            </h1>
          </div>

          {/* Hero Image */}
          <div className={`w-full max-w-2xl transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/giFgY8i4LjB3cgNpVexTGa/Cover_sic_mockup.png" alt="SIC 360 - Clases Anuales Resueltas" className="w-full h-auto drop-shadow-2xl" data-id="element-50" />
          </div>

          {/* Subpromise */}
          <div className={`max-w-3xl transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-51">
            <p className="text-xl md:text-2xl text-slate-600 leading-relaxed font-medium" data-id="element-52">
              Sistema completo de actividades, proyectos y evaluaciones{' '}
              <span className="font-bold text-slate-900" data-id="element-53">listos para usar</span>
              . Todo el año de{' '}
              <span className="font-bold text-orange-500" data-id="element-54">
                SIC I y SIC II resuelto
              </span>{' '}
              sin planificar nada desde cero.
            </p>
          </div>

          {/* CTA Button */}
          <button onClick={scrollToPurchase} className={`bg-blue-600 hover:bg-blue-700 text-white font-bold py-5 px-10 rounded-xl shadow-lg transform transition-all hover:scale-105 text-xl ${isVisible ? 'opacity-100 translate-y-0 delay-400' : 'opacity-0 translate-y-4'}`} style={{
          transitionDuration: '700ms'
        }} data-id="element-55">
            QUIERO ACCESO INMEDIATO
          </button>

          {/* Trust Indicators */}
          <div className={`flex flex-wrap items-center justify-center gap-8 text-slate-600 text-sm transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-56">
            <div className="flex items-center gap-2" data-id="element-57">
              <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-58">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-59" />
              </svg>
              <span data-id="element-60">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-61">
              <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-62">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-63" />
              </svg>
              <span data-id="element-64">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-66">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-67" />
              </svg>
              <span data-id="element-68">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}